import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/CookiePolicy.css';

const CookiePolicy = () => {
  return (
    <div className="cookie-policy">
      <div className="container">
        <h1>Cookie Policy</h1>
        <p className="last-updated">Last updated: January 10, 2026</p>

        <section className="section">
          <h2>What Are Cookies?</h2>
          <p>Cookies are small text files that are stored on your device when you visit a website. They help the website remember your actions and preferences (like login information, language, font size, and other display preferences) over a period of time, so you don't have to keep re-entering them whenever you come back to the site or browse from one page to another.</p>
        </section>

        <section className="section">
          <h2>How We Use Cookies</h2>
          <p>At Falphin, we use cookies to make our website work properly and to understand how visitors interact with our platform. Here are the types of cookies we use:</p>
          
          <div className="cookie-category">
            <h3>1. Essential Cookies</h3>
            <p>These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you, such as logging in or setting your privacy preferences.</p>
            <p><strong>Examples:</strong> Session cookies for logged-in users, security tokens, and consent management.</p>
          </div>

          <div className="cookie-category">
            <h3>2. Analytics Cookies</h3>
            <p>These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our services.</p>
            <p><strong>Examples:</strong> Page visit counts, time spent on pages, and navigation paths.</p>
          </div>
        </section>

        <section className="section">
          <h2>Your Cookie Choices</h2>
          <p>You have control over the use of non-essential cookies:</p>
          <ul>
            <li><strong>Browser Settings:</strong> Most web browsers allow you to manage your cookie preferences through the browser settings. You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies.</li>
            <li><strong>Opt-Out:</strong> You can opt out of analytics cookies by adjusting your preferences in our cookie consent banner when you first visit our site.</li>
          </ul>
          <p>Please note that disabling certain cookies may affect the functionality of our website.</p>
        </section>

        <section className="section">
          <h2>Changes to This Policy</h2>
          <p>We may update our Cookie Policy from time to time. We'll notify you of any changes by posting the new policy on this page and updating the "Last updated" date at the top.</p>
        </section>

        <section className="section">
          <h2>Contact Us</h2>
          <p>If you have any questions about our use of cookies, please contact us at <a href="mailto:privacy@falphin.com">privacy@falphin.com</a>.</p>
          <p>For more information about how we handle your personal data, please see our <Link to="/privacy">Privacy Policy</Link>.</p>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicy;
